import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { isLoggedIn } from "../session";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "./Page";

function Header({ subtitle, actions }) {
  const { carId } = useParams();
  const [carName, setCarName] = useState(""); // Corrected state name

  useEffect(() => {
    const fetchCarData = async () => {
      try {
        const db = getFirestore();
        const carDocRef = doc(db, "cars", carId);
        const carDocSnapshot = await getDoc(carDocRef);

        if (carDocSnapshot.exists()) {
          const carData = carDocSnapshot.data();
          const name = carData.title || "Vehiculo"; // Adjusted to match your data structure
          setCarName(name);
        }
      } catch {
        // Error ignorado intencionalmente
      }
    };

    if (carId) {
      fetchCarData();
    }
  }, [carId]);

  let navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <PageHeader title={carName || "Vehículo"} subtitle={subtitle} actions={actions} />
  );
}

export default Header;
